(() => {
  const videoSelector = '.js-menu-drawer-planner-video';
  const menuDrawerToggleSelector = '#Details-menu-drawer-container';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const resumeVideo = (video) => {
    if (!video) return;

    if (reducedMotion.matches) {
      video.pause();
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(() => {});
  };

  const resumePlannerVideo = () => {
    document.querySelectorAll(videoSelector).forEach(resumeVideo);
  };

  const initializePlannerVideo = () => {
    document.querySelectorAll(videoSelector).forEach((video) => {
      if (video.dataset.bbPlannerVideoInitialized === 'true') return;

      video.dataset.bbPlannerVideoInitialized = 'true';
      video.addEventListener('canplay', () => resumeVideo(video), { once: true });
      video.addEventListener('loadeddata', () => resumeVideo(video), { once: true });
    });

    const menuDrawerToggle = document.querySelector(menuDrawerToggleSelector);
    if (menuDrawerToggle && menuDrawerToggle.dataset.bbPlannerVideoToggleBound !== 'true') {
      menuDrawerToggle.dataset.bbPlannerVideoToggleBound = 'true';
      menuDrawerToggle.addEventListener('toggle', () => {
        if (menuDrawerToggle.open) resumePlannerVideo();
      });
    }

    resumePlannerVideo();
  };

  document.addEventListener('bb:cart-drawer-open', resumePlannerVideo);
  document.addEventListener('shopify:section:load', initializePlannerVideo);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePlannerVideo, { once: true });
  } else {
    initializePlannerVideo();
  }
})();
